import { defineStore } from "pinia"
import { Ocorrencias } from "@/paginas/Atividades/CalendarioDeAtividades/CalendarioDeAtividades.modelos"

export const usarOcorrenciasDoCalendarioStore = defineStore('ocorrencias-do-calendario', {
  state: (): { ocorrencias: Ocorrencias } => ({
    ocorrencias: {
      atividadeMuitoLonga: false,
      atividadeMuitoCurta: false,
      atividadeNaoPlanejada: false,
      atividadeSemOcorrencias: false,
    }
  }),

  getters: {
    possuiOcorrenciaSelecionada: (state) => {
      return Object.values(state.ocorrencias).some((ocorrencia) => ocorrencia)
    }
  },

  actions: {
    limparOcorrencias() {
      this.ocorrencias = {
        atividadeMuitoLonga: false,
        atividadeMuitoCurta: false,
        atividadeNaoPlanejada: false,
        atividadeSemOcorrencias: false,
      }
    }
  }
})
